import { Outlet, RouteObject } from "react-router-dom";

import PrivateRoutes from "./components/PrivateRoutes";
import ForgetPasswordPage from "./pages/forgetPassword/ForgetPasswordPage";
import ResetPasswordPage from "./pages/resetPassword/ResetPasswordPage";

import SignalRProvider from "./components/SignalR/SignalRProvider";
import rootLoader from "./loaders/rootLoader";
import ChangePasswordPage from "./pages/changePassword/changePasswordPage";
import ConfirmEmailPage from "./pages/ConfirmEmail";
import ErrorPage from "./pages/errorPage/ErrorPage";
import HomePage from "./pages/homePage";
import LoginPage from "./pages/loginPage/LoginPage";
import MainMenu from "./pages/MainMenu/MainMenu";
import MyRegistrationPage from "./pages/MyRegistrationPage/MyRegistrationPage";
import RegisterPage from "./pages/registerPage/RegisterPage";
import TotemStart from "./pages/TotemStart/TotemStart";
import { tokenService } from "./services/token.service";
import { totemDeviceService } from "./services/totemDevide.service";

console.log(totemDeviceService.hasTotemDevices());

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
    loader: rootLoader,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "/change-password",
        element: (
          <PrivateRoutes
            canAccess={() => tokenService.hasAccessTokens()}
            redirectUrl="/login"
          >
            <ChangePasswordPage />
          </PrivateRoutes>
        ),
      },
      {
        path: "my-registration",
        element: <MyRegistrationPage />,
      },
    ],
  },
  {
    path: "/menu",
    element: (
      <PrivateRoutes
        canAccess={() => totemDeviceService.hasTotemDevices()}
        redirectUrl="/totem-start"
      >
        <SignalRProvider>
          <Outlet />
        </SignalRProvider>
      </PrivateRoutes>
    ),
    loader: rootLoader,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <MainMenu />,
      },
    ],
  },
  {
    path: "login/:type?",
    element: (
      <PrivateRoutes
        canAccess={() => !tokenService.hasAccessTokens()}
        redirectUrl="/"
      >
        <LoginPage />
      </PrivateRoutes>
    ),
  },
  {
    path: "totem-start",
    element: <TotemStart />,
  },
  {
    path: "forget-password",
    element: <ForgetPasswordPage />,
  },
  {
    path: "email-confirmation/:userName?",
    element: <ConfirmEmailPage />,
  },
  {
    path: "reset-password/:userName",
    element: <ResetPasswordPage />,
  },
  {
    path: "register",
    element: <RegisterPage />,
  },
];

export default routes;
